import { GroupBase, OptionProps, components } from "react-select";

import { OrganisationOption } from "../types/organisation-option";

export function OrganisationSelectOption(
  props: OptionProps<
    OrganisationOption,
    boolean,
    GroupBase<OrganisationOption>
  >,
) {
  const organisation = props.data;

  return (
    <components.Option {...props}>
      <div className="flex items-center">
        <div className="ml-2">
          <p>{organisation.name}</p>
        </div>
      </div>
    </components.Option>
  );
}
